import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenDown = function ArrowCircleBrokenDown(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17 3.3378c2.989 1.729 5 4.9608 5 8.6622 0 5.5228-4.4772 10-10 10S2 17.5228 2 12c0-3.7014 2.011-6.9331 5-8.6622M8 12l4 4m0 0 4-4m-4 4V2"
    })
  }));
};
export default ArrowCircleBrokenDown;